module.exports = __webpack_public_path__ + "static/media/YF48_1.0cbcc6c1.jpg";